module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('alert', {
    attrs: {
      "dismissible": true,
      "type": "success",
      "iconClasses": ['fa', 'fa-check'],
      "title": "CoPilot is open source!"
    }
  }, [_c('span', [_vm._v("Click on icon to check it out on github.")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "https://github.com/misterGF/CoPilot",
      "target": "_blank"
    }
  }, [_c('i', {
    staticClass: "fa fa-github fa-2x"
  })])])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-6 col-xs-12"
  }, [_c('info-box', {
    attrs: {
      "color-class": "bg-aqua",
      "icon-classes": ['ion', 'ion-ios-gear-outline'],
      "text": "CPU Traffic",
      "number": "90%"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-6 col-xs-12"
  }, [_c('info-box', {
    attrs: {
      "color-class": "bg-red",
      "icon-classes": ['fa', 'fa-google-plus'],
      "text": "Likes",
      "number": "41,410"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "clearfix visible-sm-block"
  }), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-6 col-xs-12"
  }, [_c('info-box', {
    attrs: {
      "color-class": "bg-green",
      "icon-classes": ['ion', 'ion-ios-cart-outline'],
      "text": "Sales",
      "number": "760"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-6 col-xs-12"
  }, [_c('info-box', {
    attrs: {
      "color-class": "bg-yellow",
      "icon-classes": ['ion', 'ion-ios-people-outline'],
      "text": "New Members",
      "number": "2,000"
    }
  })], 1)]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-3 col-sm-6 col-xs-12"
  }, [_c('process-info-box', {
    attrs: {
      "color-class": "bg-yellow",
      "icon-classes": ['ion', 'ion-ios-pricetag-outline'],
      "text": "Inventory",
      "number": "5,200",
      "progress": 50,
      "description": "50% increase since May"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-6 col-xs-12"
  }, [_c('process-info-box', {
    attrs: {
      "color-class": "bg-green",
      "icon-classes": ['ion', 'ion-ios-heart-outline'],
      "text": "Mentions",
      "number": "92,050",
      "progress": 20,
      "description": "20% increase in 30 days"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-6 col-xs-12"
  }, [_c('process-info-box', {
    attrs: {
      "color-class": "bg-red",
      "icon-classes": ['ion', 'ion-ios-cloud-download-outline'],
      "text": "Downloads",
      "number": "114,381",
      "progress": 70,
      "description": "70% increase since yesterday"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-6 col-xs-12"
  }, [_c('process-info-box', {
    attrs: {
      "color-class": "bg-aqua",
      "icon-classes": ['ion', 'ion-ios-chatbubble-outline'],
      "text": "Direct Messages",
      "number": "163,921",
      "progress": 40,
      "description": "40% increase compared to last year"
    }
  })], 1)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "box-header with-border"
  }, [_c('h3', {
    staticClass: "box-title"
  }), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [_c('div', {
    staticClass: "col-sm-6 col-xs-12"
  }, [_c('p', {
    staticClass: "text-center"
  }, [_c('strong', [_vm._v("Web Traffic Overview")])]), _vm._v(" "), _c('canvas', {
    attrs: {
      "id": "trafficBar"
    }
  })]), _vm._v(" "), _c('hr', {
    staticClass: "visible-xs-block"
  }), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6 col-xs-12"
  }, [_c('p', {
    staticClass: "text-center"
  }, [_c('strong', [_vm._v("Language Overview")])]), _vm._v(" "), _c('canvas', {
    attrs: {
      "id": "languagePie"
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "text-center"
  }, [_c('small', [_c('b', [_vm._v("Pro Tip")]), _vm._v(" Don't forget to star us on github!")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-35bb2c8d"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/Dashboard.vue
// module id = 1266
// module chunks = 1